import { z } from "zod";

export const hotelRoomSearchSchema = z
  .object({
    location: z
      .string()
      .nullable()
      .refine((city) => city !== null, {
        message: "Lokasyon alanı boş olamaz",
      }),
  })

export default hotelRoomSearchSchema;
